export const callAPI = async (url, type, sellerData, postData, token) => {
    const _headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      SELLER_ID: sellerData.SELLER_ID,
      SELLER_UUID: sellerData.SELLER_UUID,
    };
    if (type === 'POST' || type === 'PATCH') {
        const response = await fetch(url, {
          method: type,
          headers: _headers,
          body: JSON.stringify(postData),
        });

        if (response.ok){
            return response.json().then(json => {
                return Promise.resolve({type: "dataSuccess", data : json})
            }).catch(err => {
                // the status was ok but there is no json body
                return Promise.resolve({type : "success"});
            });
        }
         else {
        return response.json().catch(err => {
            // the status was not ok and there is no json body
            return ({type : "other error"});
        }).then(json => {
            // the status was not ok but there is a json body
            return ({type : "error"}); // example error message returned by a REST API
        });
    }
}
    else {
        const response = await fetch(url, {
          method: type,
          headers: _headers,
        });
        if (response.ok){
            return response.json().then(json => {
                return Promise.resolve({type: "dataSuccess", data : json})
            }).catch(err => {
                // the status was ok but there is no json body
                return Promise.resolve({type : "success"});
            });
        }
         else {
        return response.json().catch(err => {
            // the status was not ok and there is no json body
            return ({type : "other error"});
        }).then(json => {
            // the status was not ok but there is a json body
            return ({type : "error"}); // example error message returned by a REST API
        });
    }
    }
  };
  